import { faInfoCircle } from "@fortawesome/sharp-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./help-tip.css";

export function HelpTip(props) {
    return (
        <div className={`eone-help-tip-container-${props.Theme}`}>
            <div className={`eone-help-tip-text-${props.Theme}`}>
                <FontAwesomeIcon icon={faInfoCircle} />
            </div>
            <div className={`eone-help-tip-text-${props.Theme}`}>
                {props.Tip}
            </div>
        </div>
    );
}